import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Hotel from '../components/Hotel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Container from "@mui/material/Container";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
   color: "#fff",
  fontFamily: '"Penna"',
  fontSize: "1.8rem",
  fontWeight: "bold",
}));


function Ricevimento() {

  return (
<Container maxWidth="xl" sx={{ pt: "1em" }}>
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Item sx={{backgroundColor: "transparent"}}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="stretch" justifyContent="center"
          sx={{
              display: { xs: "flex", md: "none" },
            }}>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ color: "#fff", paddingTop: "10px", paddingBottom: "10px", fontFamily: '"Penna"', fontWeight: "bold",
                  fontSize: "1.8rem", }}>
              Passiamo alla parte divertente! In attesa che lo sposo si liberi dalle grinfie della
sposa e del fotografo, potrete ingannare l'attesa con un aperitivo di benvenuto
presso il Royal Hotel di Sanremo. A seguire sara' servita la cena sulla terrazza
"Corallina".
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Hotel />
            </Grid>
            <Grid item xs={12}>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d719.7554120701091!2d7.767894869713027!3d43.81391036592413!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12cdf541f198b745%3A0x1d91818d9174fa4f!2sCorso%20Imperatrice%2C%2080%2C%2018038%20Sanremo%20IM%2C%20Italy!5e0!3m2!1sen!2sat!4v1768575967839!5m2!1sen!2sat"
                style={{ border: 0, width: "100%", minHeight: "500px", height:"640px" }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title='map'></iframe>
            </Grid>
          </Grid>
          {/* web */}
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="stretch" justifyContent="center" sx={{
              display: { xs: "none", md: "flex" },
            }}>
            <Grid item xs={0} sm={6}>
              <Hotel />
            </Grid>
            <Grid item xs={0} sm={6}>
              <Typography variant="body1" sx={{color: "#fff", paddingTop: "10px", paddingBottom: "10px", fontFamily: '"Penna"', fontWeight: "bold",
                  fontSize: "1.8rem",}}>
              Passiamo alla parte divertente! In attesa che lo sposo si liberi dalle grinfie della
sposa e del fotografo, potrete ingannare l'attesa con un aperitivo di benvenuto
presso il Royal Hotel di Sanremo. A seguire sara' servita la cena sulla terrazza
"Corallina".
              </Typography>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d719.7554120701091!2d7.767894869713027!3d43.81391036592413!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12cdf541f198b745%3A0x1d91818d9174fa4f!2sCorso%20Imperatrice%2C%2080%2C%2018038%20Sanremo%20IM%2C%20Italy!5e0!3m2!1sen!2sat!4v1768575967839!5m2!1sen!2sat"
                style={{ border: 0, width: "100%", minHeight: "500px", height:"640px" }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title='map'></iframe>
            </Grid>
          </Grid>
        </Item>
      </Stack>

    </Box>
</Container>

  )
}

export default Ricevimento;